@if (deviceDetector.isMobile()) {
  <!-- Mobile view -->
  <app-page-wrapper [title]="'earn' | i18n">
    <div class="tw-border-2 tw-flex tw-gap-4 tw-border-highlight-200 tw-rounded-xl tw-p-4">
      <span>😊</span>
      <div class="tw-flex tw-flex-col tw-gap-2">
        <span class="tw-text-dt-text-warning"> This feature is only available on Desktop. </span>
        <span>
          We recommend using the desktop version of the GLOSS Vault for the best experience.
        </span>
      </div>
    </div>
  </app-page-wrapper>
} @else {
  <!-- Desktop version -->
  <app-page-wrapper [title]="'earn' | i18n">
    <div class="tw-flex tw-flex-col tw-w-full tw-h-full">
      <!-- Header tabs -->
      <div role="tablist" class="tw-flex tw-gap-x-4 tw-px-5">
        <button
          type="button"
          (click)="selectSection('history')"
          class="tw-px-6 tw-py-3 tw-rounded-t-xl"
          [ngClass]="{
            'tw-bg-dt-surface-elevated tw-text-teal-600 tw-font-semibold tw-border-0 tw-border-b-2 tw-border-solid tw-border-teal-600':
              earnService.activeSection() === 'history',
            'tw-text-dt-text-secondary hover:tw-bg-dt-surface-sunken':
              earnService.activeSection() !== 'history',
          }"
          role="tab"
          [attr.aria-selected]="earnService.activeSection() === 'history'"
        >
          Version History
        </button>
        <button
          type="button"
          (click)="selectSection('create')"
          class="tw-px-6 tw-py-3 tw-rounded-t-xl"
          [ngClass]="{
            'tw-bg-dt-surface-elevated tw-text-teal-600 tw-font-semibold tw-border-0 tw-border-b-2 tw-border-solid tw-border-teal-600':
              earnService.activeSection() === 'create',
            'tw-text-dt-text-secondary hover:tw-bg-dt-surface-sunken':
              earnService.activeSection() !== 'create',
          }"
          role="tab"
          [attr.aria-selected]="earnService.activeSection() === 'create'"
        >
          Create and Publish {{ versionInHeader() }}
        </button>
      </div>

      <!--     Tab Content-->
      <div class="tw-bg-dt-surface-elevated tw-rounded-lg tw-py-4">
        @switch (earnService.activeSection()) {
          @case ("history") {
            <app-version-history></app-version-history>
          }

          @case ("create") {
            <app-create-and-publish></app-create-and-publish>
          }
        }
      </div>
    </div>
  </app-page-wrapper>
}
